import React, { Fragment, useState, useContext, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom'; // Corrected import for useParams
import { updateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const BankCreate = () => {
    const { id: recordId } = useParams(); // Use useParams to get the record ID from the URL
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [formData, setFormData] = useState({
        AccountName: '',
        AccountNo: '',
        IFSCCode: '',
        BranchName: '',
        OpeningBalance: '',
        AddressLine1: '',
        AddressLine2: '',
        ContactNumber: '',
        Branch: '',
        CompanyId: companyId,
    });

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : type === 'radio' ? value === 'true' : value,
        }));
    };

    const submitData = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.AccountNo) { 
            setErrorMessage("Account Number is required!");
            setIsLoading(false);
            return;
        }

        if (!formData.AccountName) { 
            setErrorMessage("Name is required!");
            setIsLoading(false);
            return;
        }

        if (!formData.BranchName) { 
            setErrorMessage("Branch Name is required!");
            setIsLoading(false);
            return;
        }

        if (!formData.IFSCCode) { 
            setErrorMessage("IFSC Code is required!");
            setIsLoading(false);
            return;
        }

        if (!formData.AddressLine1) { 
            setErrorMessage("Address Line 1  is required!");
            setIsLoading(false);
            return;
        }


        const CreateData = {
            ...formData,
            UpdatedBy: userId,
            CompanyId: companyId,
        };




        postData('BankApi', CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/BankIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    const phoneNumberPattern = /^\d{10}$/;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;

    return (
        <Fragment>
            <div className="w-full max-w-full md:max-w-sm container mt-6 mx-auto px-4">

                <form onSubmit={submitData}>

                    <div className="w-full mb-2 flex">
                        <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}> BANK CREATE</h6>
                        <Tooltip title="Exit">
                            <Link to="/bankindex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'brown', fontWeight: 'bolder', marginBottom: '10px' }}>
                                    Back To List <ArrowForwardIosIcon />
                                </Button>
                            </Link>
                        </Tooltip>
                        <Tooltip title="SAVE">
                            <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder', marginLeft: '10px', marginTop: '-10px' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>
                        </Tooltip>
                    </div>

                    {errorMessage && (
                        <div style={{ color: 'red', marginBottom: '10px' }}>
                            {errorMessage}
                        </div>
                    )}

                    <div className="w-full mb-2 flex flex-col md:flex-row">

                        <div className="w-full md:w-1/2 mb-4 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="contactNumber1">
                                Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="AccountName"
                                value={formData.AccountName}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter name"
                                required
                                maxLength={150}
                            />
                        </div>

                        <div className="w-full md:w-1/4 mb-4 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="AccountNo">
                                Account Number <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="AccountNo"
                                value={formData.AccountNo}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter AccountNo"
                                required
                                maxLength={150}
                            />
                        </div>

                        <div className="w-full md:w-1/2 mb-4 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="contactNumber1">
                                Branch Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="BranchName"
                                value={formData.BranchName}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Branch Name"
                                required
                                maxLength={130}
                            />
                        </div>

                        <div className="w-full md:w-1/4 mb-4 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="email">
                                IFSC <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="IFSCCode"
                                value={formData.IFSCCode}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter IFSC Code"
                                maxLength={40}
                            />
                        </div>

                        <div className="w-full md:w-1/4 mb-4 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="OpeningBalance">
                                Opening Balance
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="OpeningBalance"
                                value={formData.OpeningBalance}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter OpeningBalance"
                                maxLength={40}
                                style={{ textAlign: 'right' }}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Contact Number
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name='ContactNumber'
                                value={formData.ContactNumber}
                                onChange={handleChange} type="text"
                                placeholder="Enter Contact Number" />
                        </div>


                    </div>

                    <div className="w-full mb-4 flex flex-col md:flex-row">
                        <div className="w-full md:w-2/4 mb-4 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="email">
                                Address Line 1 <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="AddressLine1"
                                value={formData.AddressLine1}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Address Line 1"

                            />
                        </div>

                        <div className="w-full md:w-2/4 mb-4 md:mb-0 md:mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="openingBalance">
                                Address Line 2
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                name="AddressLine2"
                                value={formData.AddressLine2}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Address Line 2"
                            />
                        </div>

                    </div>

                </form>
            </div>
        </Fragment>
    );
};

export default BankCreate;
